// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ecos... Remove this comment to see the full error message
import { getTrackingParams } from 'ecosystem-marketplace-solutions-base/selectors/app';
import { getAppShortlink, getFullLocationPathname
// @ts-expect-error untyped import
} from 'ecosystem-marketplace-solutions-base/utils/urls';
import * as AppContext from 'ecosystem-marketplace-solutions-base/constants/AppContext';
import { Application as ApplicationComponent } from 'foundations-components/components/Application';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { useShortlinkParams } from 'marketplace-ui-common/hooks/useShortlinkParams';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Application({
  children
}) {
  const {
    pathname,
    search
  } = useLocation();
  const trackingParams = useSelector(getTrackingParams);
  const shortlinkParams = useShortlinkParams(trackingParams);
  const marketingNavLocation = useMemo(() => ({
    pathname: getFullLocationPathname(pathname, AppContext.PUBLIC, 'en'),
    search
  }), [pathname, search]);
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: /*#__PURE__*/_jsx(ApplicationComponent, {
      name: "ecosystem-marketplace-solutions-public-ui",
      children: /*#__PURE__*/_jsx(MarketingNav, {
        location: marketingNavLocation,
        loginUrl: getAppShortlink(pathname, shortlinkParams),
        useEmbeddedGlobalNav: true,
        children: /*#__PURE__*/_jsx(Box, {
          grow: 1,
          shrink: 1,
          minBlockSize: "100vh",
          children: children
        })
      })
    })
  });
}